export const RenegociacaoTabs = {
  'renegociacao-santander-financiamentos': {
    id: 0,
    href: 'renegociacao-santander-financiamentos',
    label: 'Financiamento',
    navigate: true,
    t: '',
  },
  'renegociacao-santander-emprestimos': {
    id: 1,
    href: 'renegociacao-santander-emprestimos',
    label: 'Empréstimo com garantia',
    navigate: true,
    t: '',
  },
};
